export default __webpack_public_path__ + "static/help-page-hero-4e68b0d24c1bbdabeac3f1535aa36135.png";